export const messages = {
  en: {
	navbar: {
		business: "Our services",
		ref: "References",
		contact: "Contact"
	},
	services: {
	  	title: 'Our services',
	  	branding_title: 'Branding',
	  	branding_text: 'We create brand assets and packaging design.',
	  	movie_title: 'Movie',
	  	movie_text: 'Image, commerce, music, animation.',
	  	movie_text2: "We always work with the best crew.",
	  	social_title: 'Social media',
	  	social_text: 'Be present on all platforms.',
	  	social_text2: "Start your online marketing with Us!",
	  	web_title: 'Webdevelopment',
	  	web_text: 'Be available online.',
	  	web_text2: 'We offer unique website desing and our own webshop platform.',
	  	more: 'More info'
	},
	branding: {
		title: "Branding",
		first: "Creating the branding from scratch is a complex process. We are here to guide you through the end-to-end process from the planning phase to the execution.",
		sec: "Whether you need a logo or you need branded assets we are more than happy to work with you to achieve your goals.",
		third: "We have experts in our team who are in the wholesale industry with real life experience on what makes a product successful. We offer this experience to launch your product."
	},
	movie: {
		title: "Movie",
		first: "Nowadays video content is the most successful marketing asset.",
		sec: "We work with the best Hungarian video professionals to provide you the best quality.",
		third: "As a full service digital agency we are ready to help you with any video and animation whether it is a short instagram post or a professional TV commerce series."
	},
	social: {
		title: "Social media",
		first: "Today social media sites are the main marketing and commerce platforms.",
		sec: "Do you need help with setting up your profile? You’d like to start your first campaign?",
		third: "We’re here to develop the best package for you so you can start developing your business immediately."
	},
	webdesign: {
		title: "Webdesign",
		first: "Be visible online.",
		sec: "We have a team of developers ready create a stunning website for you so you won’t miss any opportunity to generate business.",
		third: "We developed our own webshop platform so you can start selling online as quickly as possible."
	},
	other: {
		offer: "Call for an offer",
		ref: "References",
		more_info: "More details"
	},
	contact: {
		title: "Reach out to us",
		text: "Whether you need further information about our services or you are about to start a new project please complete the form on the right and we’ll get back to you by a blink of an eye."
	},
	footer: {
		contact: "Contact",
		sitemap: "Sitemap"
	}
  },
  hu: {
  	navbar: {
		business: "Szolgáltatások",
		ref: "Referenciák",
		contact: "Kapcsolat"
	},
	services: {
	  	title: 'Szolgáltatásaink',
	  	branding_title: 'Branding',
	  	branding_text: 'Teljes arculat tervezés. Csomagolás tervezés.',
	  	movie_title: 'Film',
	  	movie_text: 'Image film, reklám, videoklip, animáció.',
	  	movie_text2: "Mindig a legjobb csapattal dolgozunk.",
	  	social_title: 'Social media',
	  	social_text: 'Légy jelen minden platformon.',
	  	social_text2: "Kezd el velünk az online megjelenésed!",
	  	web_title: 'Webfejlesztés',
	  	web_text: 'Érjen el mindenki online.',
	  	web_text2: 'Webshop bérlés és egyedi fejlesztés.',
	  	more: 'Részletek'
	},
	branding: {
		title: "Branding",
		first: "Egy új márka arculatának létrehozása komplex feladat.",
		sec: "Mi a teljes folyamatban segítünk a tervezéstől a megvalósításig. Legyen szó új logoról, névjegykártyáról vagy brandingelt online és offline eszközökről, szívesen segítünk.",
		third: "Már csak a tökéletes csomagolás hiányzik? Csapatunkban olyan szakértők vannak, akik jelenleg is a kereskedelem szereplői, ezért naprakész tapasztalatuk van arról, hogy mitől lesz sikeres egy termék."
	},
	movie: {
		title: "Film",
		first: "Az online marketing egyik leghatásosabb eszköze a mozgókép.",
		sec: "A magyar filmes szakma legjobbjaival dolgozunk együtt, hogy mindig a leghatékonyabb formában juttassuk el üzeneted a célközönséghez.",
		third: "Legyen szó egy pár másodperces insta posztról vagy egy több részből álló TV-s reklámkampányról, Full Service ügynökségként rendezőink és operatőreink minden részlet kidolgozásában segítenek."
	},
	social: {
		title: "Social",
		first: "A social media felületek a reklám és az eladás ösztönzés legfontosabb színterei.",
		sec: "Nem tudod hogyan kezdd el felépíteni social media profilodat? Szeretnéd, ha más készítené a posztjaidat?",
		third: "Kidolgozzuk a számodra leghatékonyabb kampányt, megvalósítjuk és nyomon követjük az eredményeket. Írj nekünk és elkészítjük az igényeidnek megfelelő ajánlatot."
	},
 	webdesign: {
		title: "Webdesign",
		first: "Szeretnéd láthatóvá tenni vállalkozásod?",
		sec: "Egyedi honlap fejlesztésével bárki számára elérhetővé teheted szolgáltatásaidat, termékeidet.",
		third: "Saját fejlesztésű webshop platformunkkal gyorsan elkezdheted az online kereskedést és a különböző finanszírozási megoldásainknak köszönhetően a beruházás miatt sem kell aggódnod."
	},
	other: {
		offer: "Ajánlatkérés",
		ref: "Referenciák",
		more_info: "Bővebben"
	},
	contact: {
		title: "Keress minket",
		text: "Ha információra van szükséged vagy egy következő projektbe kezdenél, töltsd ki a jobb oldali űrlapot és mi a lehető legrövidebb idő alatt felvesszük veled a kapcsolatot."
	},
	footer: {
		contact: "Kapcsolat",
		sitemap: "Oldaltérkép"
	}
  }
};


// WEBPACK FOOTER //
// ./src/i18n.js